import {Temp} from "../utils/Temp.js";
import {getElementMeasure} from "@fd/helpers/DomUtils.js";
import {un$} from "@/utils/WebPreview.js";

export const WIDTH_AS_WIDGET = -1;

export class DropDown {
	/**
	 * @param widget widget under which should be drop down placed (probably <input>)
	 */
	constructor(widget) {
		this.widget = widget;
		this.inPanel = false;
	}

	get ui() {
		if (this.root == null) this.rebuild();
		return this.root;
	}

	rebuild() {
		this.root = this.makePanel();
		this.visible = false;
		this.root.on('mouseenter', function() {
			this.inPanel = true;
			this.unregisterBodyClick();
		}.bind(this));
		this.root.on('mouseleave', function() {
			this.registerBodyClick();
			this.inPanel = false;
		}.bind(this));

		this.widget.on('mouseenter', this.unregisterBodyClick.bind(this));
		this.widget.on('mouseleave', this.registerBodyClick.bind(this));
	}

	shouldBeVisible(optionalData) {
		this.cancelDropDownHide();
		if (!this.visible) {
			this.beforeShow();
			$("body").append(this.ui);
			this.visible = true;
		}
	}

	/**
	 * Overwrite this to do stuff just before dd display
	 */
	beforeShow() {
		const wm = getElementMeasure(un$(this.widget));
		let place = null;
		if (wm.spaceBottom > this.getMinHeight()) {
			place = "bottom";
		} else {
			if (wm.spaceTop > this.getMinHeight()) place = "top";
			else place = wm.spaceBottom >= wm.spaceTop ? "bottom" : "top";
		}


		// let wo = this.widget.offset();
		// let height = this.widget.outerHeight(false);
		// //console.log("Widget offset = " + JSON.stringify(wo) + ", height = " + height);
		//
		// // Screen
		// var viewportTop = $(window).scrollTop();
		// var viewportBottom = viewportTop + $(window).height();
		// var spaceAbove = Math.floor(wo.top - viewportTop);
		// var spaceBellow = Math.floor(viewportBottom - wo.top - height);
		// //console.log("Above = " + spaceAbove + ", Bellow = " + spaceBellow);
		//
		// let place = null;
		// // Select where to place dropdown ... bottom preferred
		// if (spaceBellow > this.getMinHeight()) {	// absolute minimum to consider bottom placement
		// 	place = "bottom";
		// } else {
		// 	if (spaceAbove > this.getMinHeight()) place = "top";
		// 	else place = spaceBellow >= spaceAbove ? "bottom" : "top";
		// }

		if (place === "bottom") {
			this.ui
				.css("bottom", "unset")
				.css("top", Math.floor(wm.top + wm.height + 3) + "px")
				.css("left", Math.round(wm.left) + "px");
			let maxHeight = Math.round(this.getMaxHeight() === 0 ? (wm.spaceBottom - 4) : Math.min(this.getMaxHeight(), wm.spaceBottom - 4));
			this.ui.css("max-height", maxHeight + "px");
		} else {
			const docBottom = wm.docHeight;
			const wTopFromBottom = docBottom - wm.top;
			this.ui
				.css("top", "unset")
				.css("bottom", Math.floor(wTopFromBottom + 3) + "px")
				.css("left", Math.round(wm.left) + "px");
			let maxHeight = Math.round(this.getMaxHeight() === 0 ? (wm.spaceTop - 4) : Math.min(this.getMaxHeight(), wm.spaceTop - 4));
			this.ui.css("max-height", maxHeight + "px");
		}
	}

	shouldBeHidden(evenIfInPanel) {
		if (this.visible && this.hideTimeout == null && (!this.inPanel || evenIfInPanel)) {
			this.hideTimeout = setTimeout(function () {
				//this.ui.hide();
				this.ui.detach();
				this.visible = false;
				this.hideTimeout = null;
			}.bind(this), 100);
		}
	}

	cancelDropDownHide() {
		if (this.hideTimeout != null) {
			clearTimeout(this.hideTimeout);
			this.hideTimeout = null;
		}
	}

	makePanel() {
		return Temp.tag('div', {clazz: 'dd'});
	}

	registerBodyClick() {
		$("body").on("click.dd", function() {
			this.shouldBeHidden(false);
		}.bind(this));
	}

	unregisterBodyClick() {
		$("body").off("click.dd");
	}

	/**
	 * @return {number} minimum width of dropdown. Use WIDTH_AS_WIDGET constant to set min width to the same value as widget width. 0 = unset
	 */
	getMinWidth() {
		return 0;
	}

	/**
	 * @return {number} maximum width of dropdown. Use WIDTH_AS_WIDGET constant to set max width to the same value as widget width. 0 = unset
	 */
	getMaxWidth() {
		return 0;
	}

	/**
	 * @return {number} Minimum height of sreen space to place dd panel. Used to decide if the panel will be bellow or above widget. Default 80.
	 */
	getMinHeight() {
		return 80;
	}

	/**
	 * @return {number} maximum height of dropdown panel. 0 = maximum height is determined by screen real estate
	 */
	getMaxHeight() {
		return 0;
	}
}
